"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerSection = void 0;

var react_1 = __importDefault(require("react"));

var identity_1 = require("../../identity");

var ContainerSection = function ContainerSection(_a) {
  var children = _a.children,
      cssStyle = _a.cssStyle,
      theme = _a.theme,
      _b = _a.marginBottom,
      marginBottom = _b === void 0 ? false : _b,
      _c = _a.marginTop,
      marginTop = _c === void 0 ? false : _c,
      _d = _a.paddingBottom,
      paddingBottom = _d === void 0 ? false : _d,
      _e = _a.paddingTop,
      paddingTop = _e === void 0 ? false : _e;
  var style = "container mx-auto " + (0, identity_1.defTextMargin)(marginBottom, marginTop) + " " + (0, identity_1.defTextPadding)(paddingBottom, paddingTop) + " " + (cssStyle ? cssStyle : "") + " " + (theme ? theme.body.backgroundColor : "bg-gray-100") + " " + (theme ? theme.body.textColor : "text-gray-800");
  return react_1["default"].createElement("section", {
    className: style
  }, children);
};

exports.ContainerSection = ContainerSection;